import { createWebHistory, createRouter } from "vue-router";
import Home from "../views/Home.vue";
import Login from "../views/Login.vue";
import Register from "../views/Register.vue";
import ChangePass from "../views/ChangePass.vue";
import Unauthorized from "../views/Unauthorized.vue";
import LoginAdmin from "../views/LoginAdmin.vue";
import OnBoardingDriver from "../views/OnBoardingDriver.vue";
import OnBoardingParker from "../views/OnBoardingParker.vue";
import FindParkers from "../views/FindParkers.vue";
import Garaje from "../views/Garaje.vue";
import SolicitarGaraje from "../views/SolicitarGaraje.vue";
import CreateParker from "../views/CreateParker.vue";
import CreateDriver from "../views/CreateDriver.vue";
import store from '../store';


const routes = [
  {
    path: "/Home",
    name: "Home",
    component: Home,
    meta: { showFooter: false, showHeader: true, authorized: true },
  },
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: { showFooter: false, showHeader: true, authorized: true },
  },
  {
    path: "/on-boarding-driver",
    name: "on-boarding-driver",
    component: OnBoardingDriver,
    meta: { showFooter: false, authorized: false, fullpage:true  },
  },
  {
    path: "/on-boarding-parker",
    name: "on-boarding-parker",
    component: OnBoardingParker,
    meta: { showFooter: false, authorized: false, fullpage:true  },
  },
  {
    path: "/create-parker",
    name: "create-parker",
    component: CreateParker,
    meta: { showFooter: false, showHeader: true, authorized: false, fullpage:true  },
  },
  {
    path: "/create-driver",
    name: "create-driver",
    component: CreateDriver,
    meta: { showFooter: false, showHeader: true, authorized: false, fullpage:true  },
  },
  {
    path: "/parkers",
    name: "parkers",
    component: FindParkers,
    meta: { showFooter: false, authorized: false, fullpage:true  },
  },
  {
    path: "/alquiler-garaje/:id",
    name: "garaje",
    component: Garaje,
    meta: { showFooter: false, showHeader: true, authorized: false, fullpage:true  },
  },
  {
    path: "/solicitar-garaje/:id",
    name: "solicitar-garaje",
    component: SolicitarGaraje,
    meta: { showFooter: false, showHeader: true, authorized: false, fullpage:true  },
  },
  {
    path: "/Login",
    name: "Login",
    component: Login,
    meta: { showFooter: false, authorized: false, fullpage:true  },
  },
  {
    path: "/Register",
    name: "Register",
    component: Register,
    meta: { showFooter: false, authorized: false, fullpage:true  },
  },
  {
    path: "/ChangePass/:token?",
    name: "ChangePass",
    component: ChangePass,
    meta: { showFooter: false, authorized: false  },
  },
  {
    path: "/Unauthorized",
    name: "Unauthorized",
    component: Unauthorized,
    meta: { partnerMenu: false, showFooter: false, authorized: false, fullpage:true  },
  },
  {
    path: "/LoginAdmin",
    name: "LoginAdmin",
    component: LoginAdmin,
    meta: { showFooter: false, authorized: false  },
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  await store.dispatch('initialice');
  window.scrollTo(0, 0);
  next();
});

// eslint-disable-next-line no-redeclare
/* global fbq */

router.afterEach(() => {
  if (window.fbq) {
    fbq('track', 'PageView');
  }
});

export default router;
